import { render, staticRenderFns } from "./AddCulvert.vue?vue&type=template&id=08ee5962"
import script from "./AddCulvert.vue?vue&type=script&lang=ts"
export * from "./AddCulvert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports